import { OrderType } from 'models/order.model';
import React from 'react';
import { ORDER_PROGRESS_DESCRIPTION, ORDER_PROGRESS_STEPS } from 'utils/constants';
import { ENUM_ORDER_PROGRESS } from 'utils/enum';

type Props = {
  order: OrderType;
  step: ENUM_ORDER_PROGRESS;
  onViewTimeline: (step?: ENUM_ORDER_PROGRESS) => void;
};

const OrderStatusProgress = (props: Props) => {
  const { step, onViewTimeline } = props;
  const stepGroupIndex = ORDER_PROGRESS_STEPS?.findIndex((s) => s.includes(step));
  const stepIndex = ORDER_PROGRESS_STEPS[stepGroupIndex]?.findIndex((s) => s === step);

  return (
    <div className='flex flex-col gap-5 p-5 rounded-[10px] bg-white'>
      <div className='flex items-center justify-between flex-wrap gap-2'>
        <div className='flex flex-col gap-1'>
          <p className='text-sm text-[#96999C]'>Order status</p>
          <p className='text-2xl font-medium'>{step}</p>
        </div>
        <button
          className='px-2 py-[5px] rounded-[100px] bg-[#FEF0F2] text-[#E60A2B] text-sm font-medium shrink-0'
          onClick={() => onViewTimeline(step)}>
          View timeline
        </button>
      </div>

      <div className='flex flex-col gap-3'>
        <div className='flex items-center gap-1'>
          {ORDER_PROGRESS_STEPS.map((_, index) => (
            <div
              key={index}
              className='relative grow h-[6px] rounded-full bg-[#EDEDED] overflow-hidden'>
              <span
                className={`absolute top-0 left-0 h-full rounded-full transition-all ${
                  index < stepGroupIndex
                    ? `w-full bg-[#3FB827]`
                    : index === stepGroupIndex
                    ? `${
                        stepGroupIndex === ORDER_PROGRESS_STEPS.length - 1
                          ? 'w-full'
                          : `w-[${50 + stepIndex * 25}%]`
                      } bg-[#3FB827] delay-100`
                    : `w-0`
                }`}
              />
            </div>
          ))}
        </div>
        <p className='text-sm text-[#5E6164]'>{ORDER_PROGRESS_DESCRIPTION[step]}</p>
      </div>
    </div>
  );
};

export default OrderStatusProgress;
